/**
 * @constructor
 */
function UserInfoContract() {
    /**
     * @type {string}
     */
    this.vatNr = '';

    /**
     * @type {string}
     */
    this.firmName = '';

    /**
     * @type {string}
     */
    this.firstName = '';

    /**
     * @type {string}
     */
    this.lastName = '';

    /**
     * @type {string}
     */
    this.email = '';

    /**
     * @type {string}
     */
    this.telNr = '';

    /**
     * @type {string}
     */
    this.addressLine1 = '';

    /**
     * @type {string}
     */
    this.addressLine2 = '';

    /**
     * @type {string}
     */
    this.city = '';

    /**
     * @type {string}
     */
    this.county = '';

    /**
     * @type {string}
     */
    this.zipCode = '';

    /**
     * @type {string}
     */
    this.country = 'Romania';
}

export default UserInfoContract;